import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { isMobile, login, jumpPageUrl } from '@src/common/util';
import { getHeaderHeight, getHostIndex, getHotList, goNewPage, submitApi, getindustryList, getAllDataNew } from '@src/mobile/request/2026';
import { QQShare } from '@ifeng-fe/three_terminal/es/mobile/qqShare/dynamic';
import auth, { LoginDialog } from '@ifeng-fe/ui_pc_auth';
import { ResultUrl, ListUrl, shadow, indexCommentConfig2026, qqShareCofig2026 } from '@src/constants/index';
import Card from './card';

const Layout = ({ content }) => {
    const { commentData = {} } = content;
    const { vote, voteItem } = commentData;

    const [isEnd, setIsEnd] = useState(false);
    const [commentArray, setComment] = useState([]);
    const [text, setText] = useState('');
    const [showModel, setShowModel] = useState(false);
    const [modeText, setModeText] = useState('');
    const [listData, setListData] = useState([]);
    const userInfo = auth.isLogin() ? auth.getUserInfo() : null;

    const [flag, setFlag] = useState('1'); // 1是没登录点击分类 2是点击提交评论
    const [voteId, setVoteId] = useState('');
    const [loginId, setLoginId] = useState('');

    const getCommentData = async () => {
        const { comments = [] } = await getHotList(indexCommentConfig2026.docUrl);
        
        setComment(comments);
    };

    const getAllResult = async () => {
        // const hotData = await getHostIndex();
        // let { isEnd, industries = voteItem } = hotData || {};

        // industries = industries.filter((item) => item.title !== vote.name);

        let industryList = await getindustryList(2026);

        industryList = Object.values(industryList);

        let industries = [].concat(...industryList);

        industries = industries.map((item) => ({
            title: item.name,
            ishot: item.ishot,
        }));

        setIsEnd(false);
        setListData(industries);
    };

    const checkStatus = async (voteId) => {
        try {
            if (isEnd) {
                goNewPage(`${ResultUrl}?name=${encodeURIComponent(voteId)}`);
            } else {
                goNewPage(`${ListUrl}?name=${encodeURIComponent(voteId)}`);
            }
        } catch (e) {
            goNewPage(`${ListUrl}?name=${encodeURIComponent(voteId)}`);
            console.log(e);
        }
    };

    const changeText = (text) => {
        setText(text);
    };
    const submitComment = async () => {

        // text 不能为空
        if (!text) {
            // setModeText(decodeURIComponent('评论不能为空'));
            // setShowModel(true);
            // setTimeout(() => {
            //     setModeText('');
            //     setShowModel(false);
            // }, 2000);

            return;
        } 

        const res = await submitApi({ content: text, ...indexCommentConfig2026 });
        const { code, message } = res;

        if (code === 117) {
            if (isMobile() || window.grounds) {
                window.grounds.userLogin();
            } else {
                // pc端拉起实名窗口
                auth.login(loginId);
            }
        } else if (code === 115) {
            if (!isMobile() && !window.grounds) {
                auth.login(loginId);
            }
        } else {
            setModeText(decodeURIComponent(message ? message : '评论成功'));
            setShowModel(true);
            setTimeout(() => {
                setModeText('');
                setShowModel(false);
            }, 3000);
        }
        setText('');
    };
    const submit = async () => {
        setFlag('2');
        if (login({ pcLogin: true, loginId })) {
            submitComment();
        }
    };

    const goResult = async (voteId) => {
        setVoteId(voteId);
        if (isEnd) {
            // 跳转到结果页
            goNewPage(`${ResultUrl}?name=${encodeURIComponent(voteId)}`);
        } else {
            const loginFlat = await login({ pcLogin: true, loginId });

            // 进入投票详情页面一定是登录状态
            if (loginFlat) {
                checkStatus(voteId);
            } else {
                alert('请登录用户信息后再进行投票~');
            }
        }
    };

    useEffect(() => {
        const unBindLogin = auth.event.on(auth.EVENTNAMES.login, (userInfo) => {
            // console.log('登录成功', flag, voteId);
            window.localStorage.setItem('token', userInfo.sid);
            if (flag === '1') {
                // 跳转具体分类
                checkStatus(voteId);
            } else {
                // 提交评论
                // submitComment();
            }
        });

        return () => {
            unBindLogin();
        };
    }, [flag, voteId]);

    useEffect(() => {
        if (window.localStorage.getItem('token') === 'null') {
            window.localStorage.removeItem('token');
        }
        // window.localStorage.setItem('token', userInfo.sid);
        const loginId = auth.uuid();

        setLoginId(loginId);

        // 请求 vid=金融券商 校验登录态，未登录则清除 token 和 sid
        const checkLogin = async () => {
            const result = await getAllDataNew('金融券商', 2026);

            if (result && result.code === -1) {
                window.localStorage.removeItem('token');
                document.cookie = 'sid=; path=/; domain=.ifeng.com';
            }
        };
        
        checkLogin();

        try {
            getAllResult();
        } catch (e) {
            console.log(e);
        }
        // 客户端和移动端需要先登录
        login({ pcLogin: false });

        try {
            getCommentData();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
        }
        getHeaderHeight();
    }, []);

    return (
        <div className={styles.layout}>
            <div className={styles.layout_box}>
                <div className={styles.box} />
                <div className={styles.contentbox}>
                    <div className={styles.content}>
                        <div className={styles.contentHeader}>行业分类</div>
                        {listData.map((item, index) => {
                            return <Card index={index} item={item} key={index} length={listData.length} goResult={goResult} id={item.title} />;
                        })}
                    </div>
                </div>
                {/* 热门评论 */}
                <div className={styles.commentBox}>
                    <div className={styles.comment}>热门评论</div>
                    <div>
                        {commentArray?.length > 0 &&
                            commentArray.map((item, index) => {
                                return (
                                    <div key={index} className={styles.commentText}>
                                        {item.comment_contents}
                                    </div>
                                );
                            })}
                    </div>
                    <div className={styles.textareBox}>
                        <textarea
                            value={text}
                            onChange={(e) => {
                                changeText(e.target.value);
                            }}
                            placeholder=" 你有什么想说的..."
                            className={styles.textare}
                        />
                        <div className={styles.textareImg} onClick={submit}>
                            提交
                        </div>
                    </div>

                    <div />
                </div>
            </div>
            {showModel && <div className={styles.model}>{modeText}</div>}
            <QQShare isHitBlack={true} content={qqShareCofig2026} />
            <LoginDialog id={loginId} />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
